<template>
    <div>
        <headerNotice routerName="添加秒杀"></headerNotice>
        <!-- 填写的数据 -->
        <div class="iptData">
            <!-- 数据填写 -->
            <el-form :model="formData" class="signUp_Form" label-width="150px">
                <el-row class="row">
                    <el-col :span="8">
                        <el-form-item label=" 秒杀促销名称：" :required="true">
                            <el-input
                                class="inputStyle"
                                v-model="formData.title"
                                placeholder="不能为空，1-20个字符"
                                clearable
                                size="medium"
                                maxlength="20"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="row">
                    <el-col :span="8">
                        <el-form-item label="开始日期：" :required="true">
                            <el-date-picker
                                v-model="formData.startTime"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期时间"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="row">
                    <el-col :span="8">
                        <el-form-item label="结束日期：" :required="true">
                            <el-date-picker
                                v-model="formData.endTime"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期时间"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div
                    class="reduceBox"
                    v-for="(domain, index) in formData.itemPropList"
                    :key="index"
                >
                    <el-row class="row">
                        <el-col :span="8">
                            <el-form-item label="活动开始时间：" :required="true">
                                <el-time-select
                                    placeholder="起始时间"
                                    v-model="domain.startTime"
                                    :picker-options="{
                                    start: '00:00',
                                    step: '00:30',
                                    end: '23:30'
                                    }"
                                ></el-time-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="row">
                        <el-col :span="8">
                            <el-form-item label="活动结束时间：" :required="true">
                                <el-time-select
                                    placeholder="结束时间"
                                    v-model="domain.endTime"
                                    :picker-options="{
                                    start: '00:00',
                                    step: '00:30',
                                    end: '23:30',
                                    minTime: domain.startTime
                                    }"
                                ></el-time-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="row">
                        <el-col :span="8">
                            <el-form-item label="商品选择:" :required="true">
                                <el-button
                                    style="margin-right:35px;"
                                    type="success"
                                    @click="openShowGoods(index)"
                                >选择活动商品</el-button>
                                <p style="width:200px;">已选择{{dataVal[index].oneStepLastGoods.length}}件商品</p>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-button
                        v-if="index!=0"
                        class="delBtn"
                        type="danger"
                        @click.prevent="removeCondition(index)"
                    >删除</el-button>
                </div>
                <el-form-item :rules="{required: false}" label="添加活动:" label-width="138px">
                    <el-button type="success" @click="addCondition">添加活动场次</el-button>
                </el-form-item>
                <el-row class="row">
                    <el-col :span="7">
                        <el-form-item label="限购设置：" :required="true">
                            <el-radio-group v-model="formData.limitCount">
                                <el-radio :label="0">不限购</el-radio>
                                <el-radio
                                    :label="formData.limitCount===0?'':formData.limitCount"
                                >每人每种商品限购</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col class="sale" v-if="formData.limitCount!==0" :span="4" :offset="0">
                        <el-input placeholder="请输入数量" type="number" v-model="formData.limitCount" @keyup.native="number1()">
                            <template slot="append">件</template>
                        </el-input>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col class="sale" :span="20">
                        <el-form-item label="适合的客户：" required>
                            <el-radio-group v-model="formData.customerScope">
                                <el-radio :label="1">全部客户</el-radio>
                                <el-radio :label="2">新客户</el-radio>
                                <el-radio :label="3">老客户</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="row">
                    <el-col :span="6">
                        <el-form-item label="活动范围：" :required="true">
                            <el-radio-group v-model="formData.cityScope">
                                <el-radio :label="1">全部地区</el-radio>
                                <!-- <el-radio :label="2">指定地区</el-radio> -->
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col class="sale" v-if="formData.cityScope==2" :span="4" :offset="0">
                        <el-button type="primary" @click="reginDialogVisible=true">选择地区</el-button>
                        <span>
                            &nbsp;&nbsp;&nbsp;&nbsp;已选择
                            <span
                                style="color:#f63b3b;"
                            >{{formData.cityCodes.length}}</span> 个地区
                        </span>
                    </el-col>
                </el-row>
            </el-form>
            <!-- 表格商品操作 -->
            <div class="add-box">
                <el-dialog width="1200px" title="选择商品" :visible.sync="showGoods">
                    <div class="chooseAcitveGoods">
                        <div class="title">
                            <span>*</span> 选择活动商品：
                        </div>
                        <el-tabs v-model="dataVal[index].activeName" class="tabs">
                            <el-tab-pane label="第一步：选择商品" disabled name="first">
                                <!-- 搜索栏 -->
                                <div class="searchBox">
                                    <el-row :gutter="24">
                                        <!-- 搜索框 -->
                                        <el-col :span="5" :offset="0">
                                            <el-input
                                                placeholder="请输入商品名称"
                                                v-model="dataVal[index].serachForm.word"
                                            ></el-input>
                                        </el-col>
                                        <!-- 分类搜索 -->
                                        <el-col :span="4" :offset="0">
                                            <el-select
                                                v-model="dataVal[index].serachForm.cateID"
                                                placeholder="请选择分类"
                                            >
                                                <el-option label="全部" :value="0"></el-option>
                                                <el-option
                                                    v-for="item in cateList"
                                                    :key="item.cateID"
                                                    :label="item.cateName"
                                                    :value="item.cateID"
                                                ></el-option>
                                            </el-select>
                                        </el-col>
                                        <!-- 标签搜索 -->
                                        <el-col :span="4" :offset="0">
                                            <el-select
                                                v-model="dataVal[index].serachForm.labelID"
                                                placeholder="请选择商品标签"
                                            >
                                                <el-option label="全部" :value="0"></el-option>
                                                <el-option
                                                    v-for="item in labelList"
                                                    :key="item.labelID"
                                                    :label="item.labelName"
                                                    :value="item.labelID"
                                                ></el-option>
                                            </el-select>
                                        </el-col>

                                        <el-col :span="2" :offset="0">
                                            <el-button type="primary" @click="goodsStartSearch">查询</el-button>
                                        </el-col>
                                    </el-row>
                                </div>
                                <el-table
                                    class="tableBox"
                                    :data="dataVal[index].goodsList"
                                    style="width: 100%"
                                    :default-sort="{prop: 'date', order: 'descending'}"
                                    ref="multipleTable"
                                    @selection-change="handleGoodsChange"
                                    v-loading="loading"
                                >
                                    <el-table-column
                                        type="selection"
                                        :selectable="isCanChoose"
                                        width="55"
                                    ></el-table-column>
                                    <el-table-column
                                        align="center"
                                        prop="customer"
                                        label="商品图片"
                                        width="120"
                                    >
                                        <template slot-scope="scope">
                                            <img
                                                :src="baseUrl+scope.row.imgUrl"
                                                width="100"
                                                height="100"
                                                alt
                                            >
                                        </template>
                                    </el-table-column>
                                    <el-table-column align="center" prop="title" label="商品名称"></el-table-column>
                                    <!-- <el-table-column align="center" prop="propName" label="规格"></el-table-column>
                            <el-table-column align="center" prop="propCode" label="规格编号"></el-table-column>
                                    <el-table-column align="center" prop="price" label="销售价（￥）"></el-table-column>-->
                                    <el-table-column align="center" prop="itemCode" label="商品编号"></el-table-column>
                                    <el-table-column align="center" prop="price" label="销售价（￥）"></el-table-column>
                                    <el-table-column align="center" label="操作" width="250">
                                        <template slot-scope="scope">
                                            <el-button
                                                v-if="!scope.row.checked"
                                                @click="joinDiscount(scope.row,scope.$index)"
                                                type="primary"
                                                size="small"
                                            >参加折扣</el-button>
                                            <el-button
                                                disabled
                                                v-if="scope.row.checked"
                                                type="info"
                                                size="small"
                                            >已参加</el-button>
                                            <el-button
                                                v-if="scope.row.checked"
                                                @click="cancelFirstJoin(scope.row,scope.$index)"
                                                type="danger"
                                                size="small"
                                            >取消参加</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <!--分页-->
                                <el-pagination
                                    class="pagination"
                                    @size-change="handleGoodsSizeChange"
                                    @current-change="handleGoodsCurrentChange"
                                    :page-sizes="[10, 20, 30, 40]"
                                    layout="total, sizes, next"
                                    :background="true"
                                    next-text="点击加载更多⇣⇣"
                                    :total="dataVal[index].goodsTotalCount"
                                ></el-pagination>
                                <!-- 多选操作 -->
                                <div style="margin-top: 20px">
                                    <el-button type="success" @click="choosedJoinDiscount">批量参加折扣</el-button>
                                </div>
                                <div style="text-align:center;margin-bottom:20px;">
                                    <el-button type="primary" @click="nextStep">下一步</el-button>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane disabled label="第二部：设置秒杀" name="second">
                                <div class="fastHandle">
                                    <el-table
                                        class="tableBox"
                                        :data="dataVal[index].oneStepLastGoods"
                                        style="width: 100%"
                                        :default-sort="{prop: 'date', order: 'descending'}"
                                        ref="multipleTable"
                                        @selection-change="handleSettedGoodsChange"
                                        v-loading="loading"
                                    >
                                        <el-table-column type="selection" width="55"></el-table-column>
                                        <el-table-column
                                            align="center"
                                            prop="customer"
                                            label="商品图片"
                                            width="120"
                                        >
                                            <template slot-scope="scope">
                                                <img
                                                    :src="baseUrl+scope.row.imgUrl"
                                                    width="100"
                                                    height="100"
                                                    alt
                                                >
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="userID" label="商品名称">
                                            <template slot-scope="scope">
                                                <div class="goodsInfo">
                                                    <span>
                                                        品牌名称：
                                                        <span
                                                            style="color:#999;"
                                                        >{{scope.row.title}}</span>
                                                    </span>
                                                </div>
                                                <div class="goodsInfo">
                                                    <!-- <span>规格名称：{{scope.row.propName}}</span> -->
                                                </div>
                                                <div class="goodsInfo">
                                                    <span>价格：{{scope.row.price}}</span>
                                                </div>
                                                <div class="goodsInfo">
                                                    <span>库存：{{scope.row.realStock}}</span>
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            align="center"
                                            class-name="handleTr"
                                            label="操作"
                                            width="700"
                                        >
                                            <template slot-scope="scope">
                                                <el-row>
                                                    <el-col :span="6">
                                                        <el-input
                                                            placeholder="请输入价格"
                                                            size="small"
                                                            type="number"
                                                            v-model="scope.row.secKillPrice"
                                                            @change="isOverMaxOrLowerThanMin(0,scope.row.price,scope.$index,1)"
                                                            :disabled="scope.row.discount>0"
                                                        >
                                                            <template slot="prepend">秒杀价</template>
                                                            <template slot="append">元</template>
                                                        </el-input>
                                                    </el-col>
                                                    <el-col :span="6">
                                                        <el-input
                                                            placeholder="请输入库存量"
                                                            size="small"
                                                            type="number"
                                                            v-model="scope.row.secKillStock"
                                                            @change="isOverMaxOrLowerThanMin(0,scope.row.realStock,scope.$index,2)"
                                                            @keyup.native="number(scope.$index)"
                                                        >
                                                            <template slot="prepend">秒杀库存</template>
                                                            <template slot="append">件</template>
                                                        </el-input>
                                                    </el-col>
                                                    <el-col :span="2">
                                                        <el-button
                                                            size="small"
                                                            type="danger"
                                                            @click="cancelSecondJoin(scope.row,scope.$index)"
                                                        >取消参与</el-button>
                                                    </el-col>
                                                </el-row>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <!-- 多选操作 -->
                                    <div style="margin-top: 20px">
                                        <el-button
                                            type="danger"
                                            @click="choosedCancelDiscount"
                                        >批量取消参与</el-button>
                                    </div>
                                    <div style="text-align:center;margin-bottom:20px;">
                                        <el-button type="primary" @click="preStep">上一步</el-button>
                                    </div>
                                    <!--分页-->
                                    <el-pagination
                                        class="pagination"
                                        layout="total"
                                        :total="dataVal[index].oneStepLastGoods.length"
                                    ></el-pagination>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                </el-dialog>
            </div>
            <!-- 选择区域dialog框 -->
            <el-dialog
                title="请选择活动范围区域"
                class="shieldDialog"
                :visible.sync="reginDialogVisible"
                width="30%"
            >
                <el-tree
                    v-loading="dialogLoading"
                    :data="reginData"
                    show-checkbox
                    node-key="code"
                    :default-checked-keys="defaultKeys"
                    accordion
                    :props="defaultProps"
                    ref="reginTree"
                ></el-tree>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="reginDialogVisible = false">取 消</el-button>
                    <el-button type="primary" :loading="btnLoading" @click="dialogConfirmData">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 保存按钮 -->
            <div style="text-align:center;">
                <el-button type="info" @click="cancel">返回</el-button>
                <el-button type="primary" :loading="btnLoading" @click="saveData">保存</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
export default {
    data() {
        return {
            baseUrl: this.$store.state.URL,
            loading: false,
            formData: {
                title: "",
                startTime: "",
                endTime: "",
                limitCount: 0,
                customerScope: 1,
                cityScope: 1,
                cityCodes: [],
                itemPropList: [  
                    {
                        startTime: 0,
                        endTime: 0,
                        itemPropInput: [
                            {
                                itemID: 0,
                                secKillStock: 0,
                                secKillPrice: 0
                            }
                        ]
                    }
                ]
            },
            activeName: "first",
            goodsTotalCount: 0, //商品总数据条数
            maxResultCount: 10, //默认一页显示的个数,
            cateList: [], //所有分类数据
            labelList: [], //所有变标签数据
            reginData: [], //所有区域数据
            defaultProps: {
                children: "children",
                label: "name"
            },
            defaultKeys: [], //默认已勾选的区域
            reginDialogVisible: false,
            dialogLoading: false,
            btnLoading: false,
            goodsList: [], //第一步商品列表
            serachForm: {
                //高级搜索弹框数据
                word: "",
                cateID: null,
                labelID: null
            },
            singleJoinItem: [], //第一步 右边 单个 点击参加的 商品
            choosedGoodsItem: [], //第一步 已经 勾选 的商品
            choosedJoinGoodsItem: [], //第一步 已经 勾选 要参加 的商品
            oneStepLastGoods: [], //第一步 去重  勾选等 处理完 最终的商品数组  即第二步的商品列表数组
            canIChooseTab: true, //是否能点击第二步
            allDiscountType: 1, //1全部打折 2全部减价
            allDiscountVal: "", //全部打的折扣 或者减的价格
            secondChooseGoods: [], //第二步选择的商品
            // secondMaxResultCount:2,//第二步一页显示多少个
            clearToFixed: null, //抹去角和分 2   抹去角1
            showGoods: false, // 显示商品列表
            index: 0, //活动场次下标


            dataVal: [   // 每添加一个活动场次 数组中加多一个对象
                {
                    activeName: "first",
                    goodsTotalCount: 0, //商品总数据条数
                    maxResultCount: 10, //默认一页显示的个数,
                    cateList: [], //所有分类数据
                    labelList: [], //所有变标签数据
                    reginData: [], //所有区域数据
                    defaultProps: {
                        children: "children",
                        label: "name"
                    },
                    defaultKeys: [], //默认已勾选的区域
                    reginDialogVisible: false,
                    dialogLoading: false,
                    btnLoading: false,
                    goodsList: [], //第一步商品列表
                    serachForm: {
                        //高级搜索弹框数据
                        word: "",
                        cateID: null,
                        labelID: null
                    },
                    singleJoinItem: [], //第一步 右边 单个 点击参加的 商品
                    choosedGoodsItem: [], //第一步 已经 勾选 的商品
                    choosedJoinGoodsItem: [], //第一步 已经 勾选 要参加 的商品
                    oneStepLastGoods: [], //第一步 去重  勾选等 处理完 最终的商品数组  即第二步的商品列表数组
                    canIChooseTab: true, //是否能点击第二步
                    allDiscountType: 1, //1全部打折 2全部减价
                    allDiscountVal: "", //全部打的折扣 或者减的价格
                    secondChooseGoods: [], //第二步选择的商品
                    // secondMaxResultCount:2,//第二步一页显示多少个
                    clearToFixed: null, //抹去角和分 2   抹去角1
                    showGoods: false, // 显示商品列表
                }
            ],
            dataValList: {
                activeName: "first",
                goodsTotalCount: 0, //商品总数据条数
                maxResultCount: 10, //默认一页显示的个数,
                cateList: [], //所有分类数据
                labelList: [], //所有变标签数据
                reginData: [], //所有区域数据
                defaultProps: {
                    children: "children",
                    label: "name"
                },
                defaultKeys: [], //默认已勾选的区域
                reginDialogVisible: false,
                dialogLoading: false,
                btnLoading: false,
                goodsList: [], //第一步商品列表
                serachForm: {
                    //高级搜索弹框数据
                    word: "",
                    cateID: null,
                    labelID: null
                },
                singleJoinItem: [], //第一步 右边 单个 点击参加的 商品
                choosedGoodsItem: [], //第一步 已经 勾选 的商品
                choosedJoinGoodsItem: [], //第一步 已经 勾选 要参加 的商品
                oneStepLastGoods: [], //第一步 去重  勾选等 处理完 最终的商品数组  即第二步的商品列表数组
                canIChooseTab: true, //是否能点击第二步
                allDiscountType: 1, //1全部打折 2全部减价
                allDiscountVal: "", //全部打的折扣 或者减的价格
                secondChooseGoods: [], //第二步选择的商品
                // secondMaxResultCount:2,//第二步一页显示多少个
                clearToFixed: null, //抹去角和分 2   抹去角1
                showGoods: false, // 显示商品列表
            }
        };
    },
    components: {
        headerNotice
    },
    mounted() {
        this.getSelectDatas();
        this.getAllRegin();
        // this.getGoodsListData({
        //     MaxResultCount: this.maxResultCount
        // });
    },
    methods: {
        //添加立减条件
        addCondition() {
            this.formData.itemPropList.push({
                startTime: "",
                endTime: "",
                itemPropInput: [
                    {
                        itemID: 0,
                        secKillStock: 0,
                        secKillPrice: 0
                    }
                ]
            });
            let obj = this.dataValList;
            obj = JSON.stringify(obj);
            this.dataVal.push(JSON.parse(obj));
        },
        //删除立减条件
        removeCondition(index) {
            this.formData.itemPropList.splice(index, 1);
            this.dataVal.splice(index,1);
        },
        //获取所有分类下拉
        getSelectDatas() {
            let self = this;
            //获取分类
            $http.GET({
                url:
                    this.$store.state.apiUrl +
                    "/api/services/app/AdminItem/GetCLUBList",
                success(res) {
                    self.cateList = res.cateList;
                    self.labelList = res.labelList;
                },
                fail(res) {}
            });
        },
        //获取所有省市数据
        getAllRegin() {
            let self = this;
            self.dialogLoading = true;
            $http.GET({
                url:
                    this.$store.state.apiUrl +
                    "/api/services/app/AdminSecKill/GetProvinceList",
                success(res) {
                    self.reginData = res;
                    self.reginDialogVisible = false;
                    self.dialogLoading = false;
                    self.btnLoading = false;
                },
                fail(res) {
                    self.dialogLoading = false;
                    self.btnLoading = false;
                }
            });
        },
        // 打开商品列表
        openShowGoods(index) {
            let self = this;
            self.index = index;
            self.showGoods = true;
            this.getGoodsListData({
                MaxResultCount: this.maxResultCount
            }, true, index);
        },
        //获取第一步中的商品列表
        getGoodsListData(params, isSearch, index) {
            let self = this;
            self.loading = true;
            //获取分类
            $http.GET({
                url:
                    this.$store.state.apiUrl +
                    "/api/services/app/AdminSecKill/GetItemPropList",
                params: params,
                success(res) {
                    if (isSearch) {
                        self.dataVal[index].goodsList = res.items;
                    } else {
                        self.dataVal[index].goodsList = self.dataVal[index].goodsList.concat(res.items);
                    }
                    self.dataVal[index].oneStepLastGoods.forEach((ele1, index1) => {
                        self.dataVal[index].goodsList.forEach((ele2, index2) => {
                            if (ele1.itemID == ele2.itemID) {
                                self.dataVal[index].goodsList[index2].checked = true;
                            }
                        });
                    });
                    self.dataVal[index].goodsTotalCount = res.totalCount;
                    self.$forceUpdate();
                    self.loading = false;
                },
                fail(res) {
                    self.loading = false;
                }
            });
        },
        // 第一步 table开始搜索
        goodsStartSearch() {
            let i = this.index;
            this.dataVal[i].serachForm.MaxResultCount = this.maxResultCount;
            this.dataVal[i].serachForm.SkipCount = 0;
            this.getGoodsListData(this.dataVal[i].serachForm, 1, i);
        },
        //区域选择dialog框 的确定按钮
        dialogConfirmData() {
            this.formData.cityCodes = this.$refs.reginTree.getCheckedKeys();
            this.reginDialogVisible = false;
        },
        //第一步 操作 参加秒杀折扣
        joinDiscount(row, index) {
            let i = this.index;
            this.dataVal[i].singleJoinItem.push(row);
            let flag = true;
            //判断最后一步的数组里是否有跟现在点击参与活动的商品有相同的itemID
            this.dataVal[i].oneStepLastGoods.forEach((ele, index) => {
                if (ele.itemID == row.itemID) {
                    flag = false;
                }
            });
            //如果没有相同 就push
            if (flag) {
                this.dataVal[i].oneStepLastGoods.push(row);
            }
            this.dataVal[i].goodsList[index].checked = true;
        },
        //已经参加的 禁止勾选
        isCanChoose(row, index) {
            if (row.checked) {
                return false;
            } else {
                return true;
            }
        },
        //第一步 批量 选择商品
        handleGoodsChange(val) {
            this.dataVal[this.index].choosedGoodsItem = val;
        },
        //取消第一步的参与的折扣
        cancelFirstJoin(row, index) {
            this.dataVal[this.index].goodsList[index].checked = false;
        },
        //批量勾选参加折扣
        choosedJoinDiscount(row) {
            let i = this.index;
            //让勾选的商品checked = true  即参加活动
            this.dataVal[i].choosedGoodsItem.forEach((ele, index) => {
                ele.checked = true;
            });
            //单个参与的数组与 勾选的数组合并
            let addArr = this.dataVal[i].singleJoinItem.concat(this.dataVal[i].choosedGoodsItem);
            addArr = addArr.concat(this.dataVal[i].oneStepLastGoods);
            //去重   方法 详见 assets/js/common.js 中的 reduceSameOneArr()
            addArr = $commonFn.reduceSameOneArr(addArr, "itemID");
            // 如果某个商品取消了参与  则把checked = false 商品的移除  因为splice一条数据 addArr.length遍历时减1所以最后i--
            for (let i = 0; i < addArr.length; i++) {
                if (!addArr[i].checked) {
                    addArr.splice(i, 1);
                    i--;
                }
            }
            this.dataVal[i].oneStepLastGoods = addArr;
        },
        //下一步
        nextStep() {
            let self = this;
            let index = self.index;
            //先判断是否有checked = false 商品 有就去掉
            for (let i = 0; i < this.dataVal[index].oneStepLastGoods.length; i++) {
                if (!this.dataVal[index].oneStepLastGoods[i].checked) {
                    this.dataVal[index].oneStepLastGoods.splice(i, 1);
                    i--;
                }
            }
            if (!this.dataVal[index].oneStepLastGoods.length) {
                this.$message.error("对不起，您未选择参加活动的商品");
                return;
            } else {
                this.dataVal[index].activeName = "second";
            }
        },
        //上一步
        preStep() {
            this.dataVal[this.index].activeName = "first";
        },
        // 设置限购数量为正整数
        number1(index){　　
            let i = this.index;
            this.formData.limitCount=this.formData.limitCount.replace(/[^\.\d]/g,'');
            this.formData.limitCount=this.formData.limitCount.replace('.','');
    　　},
        // 限制库存为正整数
        number(index){　　
            let i = this.index;
            this.dataVal[i].oneStepLastGoods[index].secKillStock=this.dataVal[i].oneStepLastGoods[index].secKillStock.replace(/[^\.\d]/g,'');
            this.dataVal[i].oneStepLastGoods[index].secKillStock=this.dataVal[i].oneStepLastGoods[index].secKillStock.replace('.','');
    　　},
        //第二步 判断输入值是否大于或者小于输入框的最大值以及最小值  然后给对应的输入框进行关联
        isOverMaxOrLowerThanMin(min, max, index, ways) {
            let i = this.index;
            //折扣
            if (ways == 1) {
                if (this.dataVal[i].oneStepLastGoods[index].secKillPrice < min) {
                    this.$message.error("秒杀价不能低于0元");
                    this.dataVal[i].oneStepLastGoods[index].secKillPrice = 0;
                } else if (this.dataVal[i].oneStepLastGoods[index].secKillPrice > max) {
                    this.$message.error("秒杀价不能高于原价" + max + "元");
                    this.dataVal[i].oneStepLastGoods[index].secKillPrice = 0;
                }
            }
            if (ways == 2) {
                if (this.dataVal[i].oneStepLastGoods[index].secKillStock < min) {
                    this.$message.error("库存不能低于" + min + "件");
                    this.dataVal[i].oneStepLastGoods[index].secKillStock = 0;
                } else if (this.dataVal[i].oneStepLastGoods[index].secKillStock > max) {
                    this.$message.error("库存不能高于最大库存" + max + "件");
                    this.dataVal[i].oneStepLastGoods[index].secKillStock = 0;
                }
            }
        },
        //第二步 选择的商品
        handleSettedGoodsChange(val) {
            let i = this.index;
            this.dataVal[i].secondChooseGoods = val;
        },
        //取消第二步的参与的折扣
        cancelSecondJoin(row, index) {
            let i = this.index;
            this.$confirm("确定取消该商品的优惠活动吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    this.dataVal[i].oneStepLastGoods[index].checked = false;
                    this.dataVal[i].oneStepLastGoods.splice(index, 1);
                    this.$message({
                        type: "success",
                        message: "取消成功!"
                    });
                })
                .catch(() => {});
        },
        //批量勾选取消参与折扣
        choosedCancelDiscount() {
            let i = this.index;
            this.$confirm("确定取消已选择的商品的优惠活动吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    this.dataVal[i].secondChooseGoods.forEach((ele, index) => {
                        this.dataVal[i].secondChooseGoods[index].checked = false;
                    });
                    //去除相同itemID相同的两个商品
                    //方法 详见 assets/js/common.js 中的 reduceSameTwoArr()
                    this.dataVal[i].oneStepLastGoods = $commonFn.reduceSameTwoArr(
                        this.dataVal[i].oneStepLastGoods,
                        this.dataVal[i].secondChooseGoods,
                        "itemID"
                    );
                    this.$forceUpdate();
                    this.$message({
                        type: "success",
                        message: "取消成功!"
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
        },
        //第一步 一页显示多少个
        handleGoodsSizeChange(val) {
            let i = this.index;
            this.dataVal[i].maxResultCount = val;
            let params = {
                MaxResultCount: val,
                SkipCount: 0
            };
            this.dataVal[i].goodsList = [];
            this.dataVal[i].singleJoinItem = [];
            this.dataVal[i].choosedJoinGoodsItem = [];
            this.dataVal[i].oneStepLastGoods = [];
            this.dataVal[i].secondChooseGoods = [];
            this.getGoodsListData(params, 1, i);
        },
        //第一步 跳转到指定页
        handleGoodsCurrentChange(val) {
            let i = this.index;
            this.loading = true;
            let skipCount = (val - 1) * this.dataVal[i].maxResultCount;
            let params = this.dataVal[i].serachForm;
            params.MaxResultCount = this.dataVal[i].maxResultCount;
            params.SkipCount = skipCount;
            this.getGoodsListData(params, 0, i);
        },
        //返回
        cancel() {
            this.$router.back();
        },
        //保存数据
        saveData() {
            let self = this;
            let falg = false;
            let falg1 = false;
            let falg2 = false;
            self.btnLoading = true;
            if (!this.formData.title) {
                this.$message.error("请输入秒杀促销的名称！");
                self.btnLoading = false;
                return;
            }
            if (!this.formData.startTime) {
                this.$message.error("请选择开始日期！");
                self.btnLoading = false;
                return;
            }
            if (!this.formData.endTime) {
                this.$message.error("请选择结束日期！");
                self.btnLoading = false;
                return;
            }
            this.formData.itemPropList.forEach((ele1, index1) =>{
                ele1.itemPropInput = this.dataVal[index1].oneStepLastGoods;
                if (String(ele1.startTime).length < 8) {
                    ele1.startTime = ele1.startTime + ":00";
                }
                if (String(ele1.endTime).length < 8) {
                    ele1.endTime = ele1.endTime + ":00";
                }
                if (!this.dataVal[index1].oneStepLastGoods.length) {
                    falg = true;
                }
                if (ele1.startTime.length < 8) {
                    falg1 = true;
                }
                if (ele1.endTime.length < 8) {
                    falg2 = true;
                }
            })
            if (falg1) {
                this.$message.error("请选择活动开始时间！");
                self.btnLoading = false;
                return;
            }
            if (falg2) {
                this.$message.error("请选择活动结束时间！");
                self.btnLoading = false;
                return;
            }
            if (falg) {
                this.$message.error("请选择优惠的商品！");
                self.btnLoading = false;
                return;
            }
            if (this.formData.startTime.length < 15) {
                this.formData.startTime = this.formData.startTime + ' 00:00:00';
                this.formData.endTime = this.formData.endTime + ' 23:59:59';
            }
            $http.POST({
                url:
                    this.$store.state.apiUrl +
                    "/api/services/app/AdminSecKill/Create",
                data: this.formData,
                success(res) {
                    self.$message({
                        type: "success",
                        message: "添加成功!"
                    });
                    let timer = setTimeout(() => {
                        self.btnLoading = false;
                        self.$router.back();
                        clearTimeout(timer);
                    }, 1000);
                },
                fail(res) {
                    self.btnLoading = false;
                }
            });
        }
    }
};
</script>

<style lang='scss' scoped>
//填写的数据
.iptData {
    padding: 20px 50px;
    .reduceBox {
        width: 30%;
        border: 1px solid #409eff;
        padding: 20px 115px 20px 0;
        padding-bottom: 0;
        margin-bottom: 20px;
        border-radius: 6px;
        .delBtn {
            display: block;
            margin: 0 auto;
            margin-bottom: 20px;
        }
    }
    .chooseAcitveGoods {
        .title {
            width: 140px;
            font-size: 14px;
            text-align: right;
            padding-right: 10px;
            color: #606266;
            span {
                color: #f63b3b;
            }
        }

        .tabs {
            padding: 20px 50px;
            .searchBox {
                padding-top: 20px;
            }
            .tableBox {
                margin-top: 20px;
                border: 1px solid #c5c5c5;
                /deep/ .handleTr .cell .el-row {
                    display: flex;
                    justify-content: space-between;
                    input {
                        padding: 0 5px;
                        text-align: center;
                    }
                    .el-input-group__prepend {
                        padding-left: 10px;
                        padding-right: 10px;
                    }
                    .el-input-group__append {
                        padding-left: 10px;
                        padding-right: 10px;
                    }
                }
            }
            .fastHandle {
                padding: 20px 0;
                .row {
                    display: flex;
                    align-items: center;
                }
            }
            /deep/ .el-tabs__item.is-disabled {
                color: #333;
            }
            /deep/ .pagination {
                .btn-next {
                    background: #eee;
                    color: #333;
                    padding: 0 10px;
                    border-radius: 4px;
                    border: 1px solid #c5c5c5;
                }
            }
        }
    }
}
</style>